module.exports = function (app) {
    app.controller('pages.claims.healthPlans', ['$scope', '$rootScope', '$cookies', 'benefitsDeserializer', 'services', 'coremetrics', 'updateVisited', 'session',
        function ($scope, $rootScope, $cookies, benefitsDeserializer, services, coremetrics, updateVisited, session) {
            $scope.headings = 'BENEFITS OVERVIEW';
            $scope.sidebar.data.viewState = 'loading';
            $scope.benefitsOverviewDrawer0 = true;
            $scope.nonDirectiveButtonClicked = function () {
                $scope.benefitsOverviewDrawer = !$scope.benefitsOverviewDrawer;
            };
            $scope.benefitsOverviewDrawer = false;


            services.rbsmbl.memberInfo().fetch().then(function (response) {
                    var benefits = benefitsDeserializer(response);
                    $scope.sidebar.data.benefits = benefits.benefitsData;
                    $scope.sidebar.data.benefits.curYear = 0;
                    $scope.sidebar.data.benefits.filterPlan = '';
                    $scope.sidebar.data.benefits.yearSelect = function (year) {
                        $scope.sidebar.data.benefits.filterPlan = '';
                        $scope.sidebar.data.accumsFilter = (year) ? 'previousPlans' : 'activePlans';
                    };
                    if ($scope.sidebar.data.benefits.error) {
                        $scope.sidebar.data.viewState = 'error';
                    } else {
                        $scope.sidebar.data.viewState = 'success';
                    }
                }, function (error) {
                    $scope.sidebar.data.viewState = 'error';
                }
            );

            var today = new Date();
            var memberInfo = session.data.memberInfo;
            $scope.memberList = services.rbsmbl.memberInfo().getUniqueMemberNamesArray(memberInfo);
            $scope.duplicateNames = {};
            for (var i = 0; i < $scope.memberList.length; i++) {
                var member = $scope.memberList[i];
                var name1 = member.firstName.toUpperCase() + " " + member.lastName.toUpperCase();
                var count = 1;
                if ($scope.duplicateNames[name1]) {
                    count = $scope.duplicateNames[name1];
                    count++;
                }

                $scope.duplicateNames[name1] = count;
                $scope.memberList[i].modifiers = ( (member.coverageEndDate >= today) && (member.coverageCancellationDate != '') ? ' (CANCELLED) ' : ' ');
            }
            $scope.isDuplicate = function (member) {
                var name = member.firstName.toUpperCase() + " " + member.lastName.toUpperCase();
                if ($scope.duplicateNames[name] > 1) {
                    return true;
                }
                return false;
            };

            updateVisited.mhsLanding();
        }
    ]);
};